<template>
    <div class="practicepre-dialog">
        <div class="box" :style="{ padding: showDate.isSmallTest ? '0' : '20px' }">
            <img
                v-if="showDate.practise.guideImageUrl && showDate.isSmallTest"
                :src="showDate.practise.guideImageUrl"
                style="width: 100%; max-height: calc(100vh - 135px); border-radius: 20px"
                @load="onLoad"
                @error="onError"
                alt="图片加载失败"
                :style="imageStyle"
                v-loading="isLoading"
            />
            <div class="close-btn" @click="$emit('closeDialog')">
                <div class="shadow"></div>
            </div>
            <div class="topic" v-if="!showDate.isSmallTest">{{ showDate.practise.number }}</div>
            <div class="area" v-if="!showDate.isSmallTest" v-loading="isLoading && notIframe(showDate.practise.guideVideoUrl)" :style="videoStyle">
                <img v-if="showDate.practise.guideImageUrl" :src="showDate.practise.guideImageUrl" @load="onLoad" @error="onError" alt="图片加载失败" :style="videoStyle" />
                <video v-else-if="notIframe(showDate.practise.guideVideoUrl)" :style="videoStyle" controls controlslist="nodownload" @loadedmetadata="handleLoadedMetadata">
                    <source :src="showDate.practise.guideVideoUrl" type="video/mp4" />
                </video>
                <iframe v-else :src="showDate.practise.guideVideoUrl" frameborder="0" :style="videoStyle" allow="autoplay; fullscreen; picture-in-picture; clipboard-write"> </iframe>
            </div>
            <div class="solid-btn" v-show="showBtn"  @click="practice">{{ showDate.isSmallTest ? $t("studentProgramme.goExamine") : $t("studentProgramme.goPractice") }}</div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    props: ["showDate","isAdventure"],
    data() {
        return {
            showBtn: false, // 按钮显示状态（初始隐藏）
            aspectRatio: 16 / 9,
            imageStyle: {},
            videoStyle: {},
            hasLoaded: false,
            isLoading: true,
        };
    },
    mounted() {
        this.getVideoStyle();
        this.getBackgroundStyle();
        window.onresize = () => {
            return (() => {
                if ("ontouchstart" in document.documentElement) {
                    this.hasLoaded = false;
                }
                if (!this.hasLoaded) {
                    this.getVideoStyle();
                    this.getBackgroundStyle();
                }
            })();
        };
      // 延迟显示：1000 = 1秒（可自定义，比如500=0.5秒）
      setTimeout(() => {
        this.showBtn = true;
        // 可选：添加渐显动画（配合上面的 opacity 样式）
        this.$nextTick(() => {
          const btnEl = this.$el.querySelector('.solid-btn');
          if (btnEl) btnEl.style.opacity = '1';
        });
      }, 2000);
    },
    destroyed() {
        window.onresize = null;
    },
    methods: {
        onLoad() {
            // 图片地址
            var img_url = this.showDate.practise.guideImageUrl;
            // 创建对象
            var img = new Image();
            // 改变图片的src
            img.src = img_url;
            // 加载完成执行
            this.aspectRatio = img.width / img.height;
            this.isLoading = false;
            this.hasLoaded = true;
            this.getVideoStyle();
            this.getBackgroundStyle();
            // this.imageStyle = {
            //     width: "100%",
            //     maxHeight: "calc(100vh - 135px)",
            //     display: "block",
            // };
            // this.videoStyle = {
            //     width: "100%",
            //     maxHeight: "calc(100vh - 215px)",
            //     display: "block",
            // };
        },
        onError() {
            this.isLoading = false;
        },
        getBackgroundStyle() {
            let innerWidth = window.innerWidth - 15;
            let innerHeight = window.innerHeight;
            let maxWidth = innerWidth * 0.7;
            let maxHeight = innerHeight - 135;
            let changeHeight = maxWidth / this.aspectRatio;
            let changeWidth = maxHeight * this.aspectRatio;
            if (changeHeight >= maxHeight) {
                this.imageStyle = {
                    width: changeWidth + "px",
                    height: maxHeight + "px",
                    display: "block",
                };
            } else if (changeWidth >= maxWidth) {
                this.imageStyle = {
                    width: maxWidth + "px",
                    height: changeHeight + "px",
                    display: "block",
                };
            }
        },
        getVideoStyle() {
            let innerWidth = window.innerWidth - 15;
            let innerHeight = window.innerHeight;
            let maxWidth = innerWidth * 0.7 - 40;
            // let maxHeight = innerHeight - 215;
            let maxHeight = innerHeight - 225;
            let changeHeight = maxWidth / this.aspectRatio;
            let changeWidth = maxHeight * this.aspectRatio;
            if (changeHeight >= maxHeight) {
                this.videoStyle = {
                    width: changeWidth + "px",
                    height: maxHeight + "px",
                    display: "block",
                };
            } else if (changeWidth >= maxWidth) {
                this.videoStyle = {
                    width: maxWidth + "px",
                    height: changeHeight + "px",
                    display: "block",
                };
            }
        },
        handleLoadedMetadata() {
            this.isLoading = false;
            this.hasLoaded = true;
            this.getVideoStyle();
            // this.videoStyle = {
            //     width: "100%",
            //     maxHeight: "calc(100vh - 225px)",
            //     display: "block",
            // };
        },
        practice() {
            if (this.showDate.isSmallTest||this.isAdventure) {
                this.$router
                    .push({
                        path: `/examination?type=adventure&topicId=${this.showDate.topicsId}&id=${this.showDate.practise.id}&gradeId=${this.$store.getters.currentGradeId}&isSmallTest=${this.showDate.isSmallTest}&startTime=${moment().format('YYYY-MM-DD HH:mm:ss')}`,
                    })
                    .catch((err) => console.log(err));
            } else {
                this.$router.push({ path: "/examination", query: { type: "library", topicId:this.showDate.topicsId,id: this.showDate.practise.id,gradeId: this.$store.getters.currentGradeId,startTime: moment().format('YYYY-MM-DD HH:mm:ss')} });
            }
        },
        notIframe(url) {
            return url.includes(window.location.hostname);
        },
    },
};
</script>

<style scoped lang="scss">
.practicepre-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 100px;
    //padding-top: calc(72px + 10vh);
    //padding-bottom: 10vh;
    z-index: 2001;

    .box {
        max-width: 70vw; //600px;
        max-height: calc(100vh - 135px);
        //height: calc(80vh - 72px);//400px;
        background-color: #fff;
        border-radius: 20px;
        align-content: space-around;
        box-sizing: border-box;
        position: relative;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        .close-btn {
            position: absolute;
            top: -19px;
            right: -17px;
            width: 35px;
            height: 37px;
            border-radius: 50px;
            background-color: #b5282c;
            cursor: pointer;

            &:before,
            &:after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                width: 65%;
                height: 4px;
                border-radius: 4px;
                background-color: #fff;
                transform: rotateZ(45deg);
            }

            &:after {
                transform: rotateZ(-45deg);
            }
            .shadow {
                position: absolute;
                width: 100%;
                height: 100%;
                border-radius: 50px;
                box-shadow: inset 0 -4px 0 0 #841515;
                transition: box-shadow 0.1s linear;
            }

            &:hover {
                // opacity: .7;
                .shadow {
                    box-shadow: inset 0 -1px 0 0 #841515;
                }
            }
        }

        .topic {
            width: 100%;
            text-align: center;
            font-size: 20px;
            color: #b5282c;
            font-weight: 700;
            margin-bottom: 10px;
        }

        .area {
            flex: 1;
            width: 100%;
            border-radius: 15px;
            box-sizing: border-box;
            //position: relative;
            margin-bottom: 10px;
            //overflow: hidden;
            /* .video {
                width: 100%;
                max-height: calc(100vh - 215px);
                display: block;
            }
            img {
                object-fit: contain; //over
                width: 100%;
                max-height: calc(100vh - 225px);
                display: block;
            }
            iframe {
                width: calc(70vw - 40px);
                height: calc(100vh - 225px);
                border: none;
                display: block;
            } */
        }
        .solid-btn {
            position: absolute;
            width: 160px;
            height: 40px;
            border-radius: 40px;
            background-color: #ffb842;
            color: #333;
            font-weight: 700;
            font-size: 16px;
            text-align: center;
            cursor: pointer;
            margin-left: 10px;
            line-height: 35px;
            bottom: -25px;
            left: 0;
            right: 0;
            margin: auto;

            &:before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 40px;
                box-shadow: inset 0px -4px 1px 0 #c0811f;
            }

            &:hover {
                background-color: #f7be61;
            }
        }
    }
}
</style>
